import { render, staticRenderFns } from "./VuesticSocialNews.vue?vue&type=template&id=513ba57b&"
import script from "./VuesticSocialNews.vue?vue&type=script&lang=js&"
export * from "./VuesticSocialNews.vue?vue&type=script&lang=js&"
import style0 from "./VuesticSocialNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticSocialNews.vue"
export default component.exports